import { jsx as l, jsxs as T } from "react/jsx-runtime";
import { useRef as B, useEffect as g, createElement as _ } from "react";
import { useFoundation as v, createComponent as m, useClassNames as u, Tag as f } from "@rmwc/base";
import { IconButton as C } from "@rmwc/icon-button";
import { MDCShortTopAppBarFoundation as x, MDCFixedTopAppBarFoundation as I, MDCTopAppBarFoundation as A } from "@material/top-app-bar";
const w = (s) => {
  const t = B(null), n = B(null), { foundation: e, ...d } = v({
    props: s,
    elements: {
      rootEl: !0
    },
    foundation: ({ rootEl: o, emit: i }) => {
      const r = {
        hasClass: (a) => o.hasClass(a),
        addClass: (a) => o.addClass(a),
        removeClass: (a) => o.removeClass(a),
        setStyle: (a, h) => o.setStyle(a, h),
        getTopAppBarHeight: () => {
          var a;
          return ((a = o.ref) == null ? void 0 : a.clientHeight) || 0;
        },
        notifyNavigationIconClicked: () => i("onNav", {}),
        getViewportScrollY: () => {
          const a = t.current;
          return a ? a["pageYOffset" in a ? "pageYOffset" : "scrollTop"] : 0;
        },
        getTotalActionItems: () => o.ref ? o.ref.querySelectorAll(
          A.strings.ACTION_ITEM_SELECTOR
        ).length : 0
      };
      let c;
      return s.short ? c = new x(r) : s.fixed ? c = new I(r) : c = new A(r), c;
    }
  }), { rootEl: p } = d;
  return g(() => {
    var r, c;
    const o = s.scrollTarget || ((c = (r = p.ref) == null ? void 0 : r.ownerDocument) == null ? void 0 : c.defaultView) || window, i = e.handleTargetScroll.bind(e);
    return o.addEventListener("scroll", i), t.current = o, () => {
      o.removeEventListener("scroll", i);
    };
  }, [s.scrollTarget, t, e, p.ref]), g(() => {
    var i, r;
    n.current = ((i = p.ref) == null ? void 0 : i.querySelector(
      A.strings.NAVIGATION_ICON_SELECTOR
    )) || null;
    const o = e.handleNavigationClick.bind(e);
    return (r = n.current) == null || r.addEventListener("click", o), () => {
      var c;
      (c = n.current) == null || c.removeEventListener("click", o);
    };
  }, [p.ref, e]), g(() => {
    e.lastScrollPosition = e.adapter.getViewportScrollY(), e.topAppBarHeight = e.adapter.getTopAppBarHeight();
  }, [e]), { foundation: e, ...d };
}, E = m(
  function(t, n) {
    return /* @__PURE__ */ l(
      j,
      {
        ...t,
        ref: n
      },
      t.short ? "short" : t.fixed ? "fixed" : "top-app-bar"
    );
  }
), j = m(
  function(t, n) {
    const { rootEl: e } = w(t), {
      onNav: d,
      scrollTarget: p,
      fixed: o,
      prominent: i,
      short: r,
      shortCollapsed: c,
      dense: a,
      foundationRef: h,
      ...N
    } = t, S = u(t, [
      "mdc-top-app-bar",
      {
        "mdc-top-app-bar--fixed": o,
        "mdc-top-app-bar--prominent": i,
        "mdc-top-app-bar--short": r || c,
        "mdc-top-app-bar--short-collapsed": c,
        "mdc-top-app-bar--dense": a
      }
    ]);
    return /* @__PURE__ */ l(
      f,
      {
        tag: "header",
        ...N,
        element: e,
        className: S,
        ref: n
      }
    );
  }
), P = m(
  function(t, n) {
    const {
      title: e,
      actionItems: d,
      navigationIcon: p,
      startContent: o,
      endContent: i,
      ...r
    } = t;
    return /* @__PURE__ */ l(E, { ...r, ref: n, children: /* @__PURE__ */ T(F, { children: [
      /* @__PURE__ */ T(b, { alignStart: !0, children: [
        !!p && /* @__PURE__ */ l(
          R,
          {
            icon: "menu",
            ...typeof p == "boolean" ? {} : p
          }
        ),
        !!e && /* @__PURE__ */ l(O, { children: e }),
        o
      ] }),
      (!!d || i) && /* @__PURE__ */ T(b, { alignEnd: !0, children: [
        i,
        !!d && d.map((c, a) => /* @__PURE__ */ _(y, { ...c, key: a }))
      ] })
    ] }) });
  }
), F = m(
  function(t, n) {
    const e = u(t, ["mdc-top-app-bar__row"]);
    return /* @__PURE__ */ l(f, { ...t, ref: n, className: e });
  }
), b = m(
  function(t, n) {
    const { alignStart: e, alignEnd: d, ...p } = t, o = u(t, [
      "mdc-top-app-bar__section",
      {
        "mdc-top-app-bar__section--align-start": e,
        "mdc-top-app-bar__section--align-end": d
      }
    ]);
    return /* @__PURE__ */ l(f, { tag: "section", ...p, ref: n, className: o });
  }
), R = m(
  function(t, n) {
    const e = u(t, [
      "mdc-top-app-bar__navigation-icon"
    ]);
    return /* @__PURE__ */ l(C, { ...t, className: e, ref: n });
  }
), y = m(
  function(t, n) {
    const e = u(t, ["mdc-top-app-bar__action-item"]);
    return /* @__PURE__ */ l(C, { ...t, className: e, ref: n });
  }
), O = m(
  function(t, n) {
    const e = u(t, ["mdc-top-app-bar__title"]);
    return /* @__PURE__ */ l(f, { ...t, ref: n, className: e });
  }
), V = m(
  function(t, n) {
    const { dense: e, denseProminent: d, prominent: p, short: o, ...i } = t, r = u(t, [
      {
        "mdc-top-app-bar--fixed-adjust": !t.dense && !t.denseProminent && !t.prominent && !t.short,
        "mdc-top-app-bar--dense-fixed-adjust": t.dense,
        "mdc-top-app-bar--prominent-fixed-adjust": t.prominent,
        "mdc-top-app-bar--dense-prominent-fixed-adjust": t.denseProminent,
        "mdc-top-app-bar--short-fixed-adjust": t.short
      }
    ]);
    return /* @__PURE__ */ l(f, { ...i, ref: n, className: r });
  }
);
export {
  P as SimpleTopAppBar,
  E as TopAppBar,
  y as TopAppBarActionItem,
  V as TopAppBarFixedAdjust,
  R as TopAppBarNavigationIcon,
  F as TopAppBarRow,
  b as TopAppBarSection,
  O as TopAppBarTitle
};
